export default "__VITE_ASSET__CYTm7$pL__"